import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import '../styles/BotaoWhatsApp.css';

const BotaoWhatsApp = () => {
  const numeroWhatsApp = '5583991740119'; // Substitua pelo seu número (código do país + DDD + número)

  return (
    <a
      href={`https://wa.me/${numeroWhatsApp}`}
      className="botao-whatsapp-flutuante"
      target="_blank"
      rel="noopener noreferrer"
    >
      <FaWhatsapp size={30} />
    </a>
  );
};

export default BotaoWhatsApp;
